import { render, staticRenderFns } from "./CommentEditorBasic.vue?vue&type=template&id=875ddf16&scoped=true&"
import script from "./CommentEditorBasic.vue?vue&type=script&lang=ts&"
export * from "./CommentEditorBasic.vue?vue&type=script&lang=ts&"
import style0 from "./CommentEditorBasic.vue?vue&type=style&index=0&id=875ddf16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "875ddf16",
  null
  
)

export default component.exports